module.exports = __webpack_public_path__ + "img/45_35.602c97fb.png";